import Modal from "Components/Modal/Modal";
import { useSchedule } from "Components/Schedule/hooks/useSchedule";
import { Schedule } from "domain-entities";
import React, { FC } from "react";
import { v4 } from "uuid";
import ScheduleForm from "../Schedule/ScheduleForm";
import { useTeamsModal } from "./hooks/useTeamsModal";

const TeamsModal: FC = () => {
	const schedule = useSchedule((state) => state.item);

	const isModalOpen = useTeamsModal((state) => state.isOpen);

	if (!isModalOpen) return null;

	const newSchedule: Schedule = {
		id: v4(),
		groups: [],
	};

	return (
		<Modal modalController={useTeamsModal.getState()} fullScreen>
			<ScheduleForm schedule={schedule || newSchedule} />
		</Modal>
	);
};

export default TeamsModal;
